var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"label-width":"80px","size":"mini"}},[_c('el-form-item',{attrs:{"label":"url"}},[_c('el-input',{model:{value:(_vm.attribute.url),callback:function ($$v) {_vm.$set(_vm.attribute, "url", $$v)},expression:"attribute.url"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }